export enum Breakpoints {
  Mobile = 752,
  /* Currently everything that above Mobile breakpoint is a Desktop View: https://dev.azure.com/ppgit/Prosight(GWP)/_wiki/wikis/Prosight(GWP).wiki/5380/Decisions?anchor=2023%2C-may-18th
      Tablet = 1024,
      Desktop = 1440
    */
}
